export namespace ServicesActions {
  export class FetchAll {
    static readonly type = `[SERVICES] Fetch All`;
  }

  export class Reset {
    static readonly type = `[SERVICES] Reset All`;
  }
}
